module.exports = "pegasus_template/assets/one-column-button-preview.png";